import { render, staticRenderFns } from "./diet.vue?vue&type=template&id=7e511a82&scoped=true"
import script from "./diet.vue?vue&type=script&lang=js"
export * from "./diet.vue?vue&type=script&lang=js"
import style0 from "./diet.vue?vue&type=style&index=0&id=7e511a82&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e511a82",
  null
  
)

export default component.exports